<template>
    <el-dialog
        ref="grid-modal"
        :title="modalTitle"
        :visible="showModal"
        width="40%"
        class="grid-modal"
        append-to-body
        :show-close="false"
    >
        <el-row
            :gutter="0"
            class="grid-header"
        >
            <el-col :span="5">
                <span class="name-label">Nom de la grille</span>
            </el-col>
            <el-col
                :span="16"
                :offset="2"
                class="name-input-container"
            >
                <el-input
                    v-model="pricingData.name"
                    class="name-input"
                    placeholder="Choisissez un nom pour la grille tarifaire"
                ></el-input>
            </el-col>
        </el-row>
        <el-row
            :gutter="0"
            class="pricings"
        >
            <el-col :span="5">
                <span class="pricings-label">Tarifs</span>
            </el-col>
            <el-col
                :span="16"
                :offset="2"
                class="name-input-container"
            >
                <div class="tarif-grid">
                    <el-row :gutter="0" class="labels">
                        <el-col :span="14">
                            <div class="simulation-number">Nombre de simulations</div>
                        </el-col>
                        <el-col :span="6">
                            <div class="simulation-price">Prix</div>
                        </el-col>
                    </el-row>
                    <GridRow
                        v-for="(data, index) in pricingData.values"
                        :key="`GridRow-${index}`"
                        :data="data"
                        :index="index"
                        :plusIcon="showPlus(index)"
                        :deleteIcon="showDelete(index)"
                        class=""
                        write
                        @changeMaxValue="changeMaxValue"
                        @changePriceValue="changePriceValue"
                        @removeLine="removeLine"
                        @addLine="addLine"
                    ></GridRow>
                </div>
            </el-col>
        </el-row>
        <el-row
            :gutter="0"
            class="usage-section"
        >
            <el-col :span="5">
                <span class="usage-label">La grille est utilisée</span>
            </el-col>
            <el-col
                :span="16"
                :offset="2"
                class="usage-input-container"
            >
                <el-checkbox v-model="pricingData.in_use"></el-checkbox>
            </el-col>
        </el-row>
        <div v-if="!gridDataIsValid" class="error">Aucun champ ne peut être vide</div>
        <span slot="footer">
            <el-button @click="closeModal">Annuler</el-button>
            <el-button type="primary" :disabled="!gridDataIsValid" @click="validateModal">{{ validationButtonText }}</el-button>
        </span>
    </el-dialog>
</template>

<script>
import PricingModification from './index.vue';
import GridRow from './gridRow.vue';

export default {
    props: {
        showModal: {
            type: Boolean,
            required: true
        },
        chosenPricingGrid: {
            required: true,
            validator: prop => typeof prop === 'object' || prop === null
        }
    },
    components: {
        PricingModification,
        GridRow,
    },
    data () {
        return {
            defaultPricingData: {
                name: '',
                in_use: true,
                values: [
                    {
                        min: 1,
                        max: 10,
                        price: 10
                    },
                    {
                        min: 11,
                        max: null,
                        price: 20
                    },
                ]
            },
            pricingData: {
                name: '',
                in_use: true,
                values: []
            }
        };
    },
    mounted() {
        if (this.chosenPricingGrid) {
            this.$set(this, 'pricingData', this.chosenPricingGrid);
        } else {
            this.$set(this, 'pricingData', this.defaultPricingData);
        }
    },
    computed: {
        validationButtonText() {
            if (this.chosenPricingGrid) {
                return 'Modifier';
            }
            return 'Créer';
        },
        modalTitle() {
            if (this.chosenPricingGrid) {
                return 'Modifier la grille tarifaire';
            }
            return 'Créer une grille tarifaire';
        },
        gridDataIsValid() {
            let isValid = true;
            if (this.pricingData.name === '') {
                isValid = false;
            }
            this.pricingData.values.forEach(value => {
                if (value.price == '' || value.min == '' || value.max == '') {
                    isValid = false;
                }
            });
            return isValid;
        }

    },
    methods: {
        removeLine(index) {
            this.pricingData.values.splice(index, 1);
            this.pricingData.values[index].min = parseInt(this.pricingData.values[index - 1].max) + 1;
        },
        addLine(index) {
            let item = {
                min: parseInt(this.pricingData.values[index].max) + 1,
                max: parseInt(this.pricingData.values[index + 1].min) - 1,
                price: parseFloat(this.pricingData.values[index].price),
            };
            this.pricingData.values.splice(index + 1, 0, item);
        },
        showPlus(index) {
            return index !== this.pricingData.values.length - 1;
        },
        showDelete(index) {
            return index !== 0 && index !== this.pricingData.values.length - 1;
        },
        closeModal() {
            this.$emit('closeModal');
        },
        changeMaxValue(payload) {
            this.$set(this.pricingData.values[payload.index], 'max', payload.newValue);
            this.$set(this.pricingData.values[payload.index + 1], 'min', parseInt(payload.newValue) + 1);
        },
        changePriceValue(payload) {
            this.$set(this.pricingData.values[payload.index], 'price', payload.newValue);
        },
        validateModal() {
            if (this.chosenPricingGrid === null) {
                this.createPricingGrid();
            } else {
                this.changePricingGrid();
            }
        },
        createPricingGrid() {
            let item = {
                item: this.pricingData,
                model: 'priceLists',
                url: this.$store.state.api.meta.listModels.priceLists.url
            };
            this.$store.dispatch('createItem', item).then(() => {
                this.$notify.success({message: 'Vous avez créé une nouvelle grille tarifaire'});
            }).catch(() => {
                this.$notify.error({message: 'La nouvelle grille tarifaire n\'a pas pu être créée'});
            }).finally(() => {
                this.$emit('refreshLoader');
            });

        },
        changePricingGrid() {
            let item = {
                item: this.pricingData,
                model: 'priceLists',
            };
            this.$store.dispatch('patchItem', item).then(() => {
                this.$notify.success({message: 'Les modifications ont été prises en compte'});
            }).catch(() => {
                this.$notify.success({message: 'Les modifications ont échoué'});
            }).finally(() => {
                this.$emit('refreshLoader');
            });
        },
    }
};
</script>

<style lang="scss">
.pricings {
    margin: 20px 0;
}
.grid-modal {
    .grid-header {
        display: flex;
        align-items: center;
        .name-label {
            word-break: break-word;
        }
    }
    .tarif-grid {
        .labels {
            color: #9B9B9B;
            font-size: 10px;
            font-weight: bold;
            margin-bottom: 6px;
        }
    }
    .grid-row:nth-child(even) {
        background-color: #F3F3F3;
    }
    .usage-section {
        .usage-label {
            word-break: break-word;
        }
    }
    .error {
        color: #F56C6C;
        font-size: 14px;
    }
    .el-dialog__body {
        padding-bottom: 0;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Pricing/pricingModal.vue